import React from 'react';
import { Card, Col, Modal, Row, Space, Typography } from 'antd';
import { CtaDataObject, NotificationTemplateVariable } from '@/graphql/generated/graphql';
import { capitalize } from '@/utils';
import SendGridTemplatePreview from './SendGridTemplatePreview/SendGridTemplatePreview';

type Props = {
  isModalVisible: boolean;
  subject?: string;
  closeModal: (visible: boolean) => void;
  messageTemplate: string;
  ctaDataList?: Array<CtaDataObject>;
  variables?: NotificationTemplateVariable[];
};

const PreviewTemplateModal: React.FC<Props> = ({
  isModalVisible,
  closeModal,
  subject,
  messageTemplate,
  ctaDataList,
  variables,
}) => {
  const createTemplateBodyMarkup = (htmlString: string) => {
    return { __html: htmlString || 'No Data' };
  };

  const renderNotificationTemplate = (template: string) => {
    return <p dangerouslySetInnerHTML={createTemplateBodyMarkup(template)} />;
  };

  const parseMessageBodyWithCTAVariables = () => {
    let parsedMessage = messageTemplate;

    ctaDataList?.forEach((cta) => {
      if (cta.variable) {
        parsedMessage = parsedMessage.replaceAll(
          cta.variable,
          `<a
                      style='background-color: ${cta.color};
                      color: #FFF;
                      padding: 8px 10px;
                      text-decoration: none;'
                      target='_blank'
                      rel='noopener noreferrer'
                      href='${cta.link}'
                    >
                      ${cta.text}
                    </a>`
        );
      }
    });

    variables?.forEach((variable) => {
      parsedMessage = parsedMessage.replaceAll(`{{${variable.name}}}`, capitalize(variable.name));
    });

    return renderNotificationTemplate(parsedMessage);
  };

  const parseSubjectWithVariables = () => {
    let parsedSubject = subject;

    variables?.forEach((variable) => {
      parsedSubject = parsedSubject?.replaceAll(`{{${variable.name}}}`, capitalize(variable.name));
    });

    return parsedSubject;
  };

  return (
    <Modal
      centered
      title="Preview Notification"
      bodyStyle={{ height: 'calc(80vh - 30px)', overflow: 'auto', padding: 0 }}
      width={'calc(80vw - 30px)'}
      open={isModalVisible}
      onCancel={() => closeModal(false)}
      footer={null}
    >
      <Card bordered={false}>
        <Row gutter={[32, 32]}>
          <Col span={24}>
            <Space>
              <Typography.Text type="secondary">Subject:</Typography.Text>
              <Typography.Text strong>{parseSubjectWithVariables()}</Typography.Text>
            </Space>
          </Col>
          <Col span={24}>
            <Typography.Paragraph type="secondary">Notification Body:</Typography.Paragraph>
            <SendGridTemplatePreview>{parseMessageBodyWithCTAVariables()}</SendGridTemplatePreview>
          </Col>
        </Row>
      </Card>
    </Modal>
  );
};

export default PreviewTemplateModal;
